// extracted by mini-css-extract-plugin
module.exports = {"root":"desktop-map_root__No5vm","closeButton":"desktop-map_closeButton__Yi_oT","mapContainer":"desktop-map_mapContainer__AtkP7"};